import { getDashboard } from '@api/dashboard/dashboard.service';
import { useQuery } from '@tanstack/react-query';

export const useGetDashboard = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['dashboard'],
    queryFn: getDashboard,
  });

  return {
    isLoading,
    isError,
    data,
  };
};
